export const smsEditor = () => ({
    smsBtn: {
        cursor: 'pointer',
        marginLeft: 8
    },
    smsInput: {
        '& .MuiInputBase-input': {
            lineHeight: 1.1
        },
        '& .MuiInputBase-inputMultiline': {
            padding: '12px 0px !important'
        },
        '& textarea::placeholder': {
            fontWeight: 400,
            fontSize: '14px !important',
            color: '#333 !important',
            fontFamily: 'Roboto, Arial, "sans-serif" !important'
        }
    },
    helperText: {
        color: '#575757',
        textAlign: 'left',
        fontSize: '12px'
    },
    marginTop8px: {
        marginTop: 8
    },
    link: {
        color: '#3083EC',
        textTransform: 'none',
        textDecoration: 'none'
    }
});
